<template>
    <transition name="fade" mode="out-in">
        <div :id="svgId" class="svg-container"></div>
    </transition>
</template>

<script>

    import irelandMap from '@/assets/js/irelandMap.js';

    export default {
        name: "VenueMapComponent",
        props: {
            counties: Array
        },
        data: function () {
            return {
                svgId: "irelandMap",
                mapAttr: {
                    viewBoxWidth: 1750,
                    viewBoxHeight: 2371,
                    imageWidth: 653,
                    imageHeight: 800
                },
                svgContainer: null,
                countiesItem: []
            }
        },
        mounted: function () {
            this.generateVenueMap()
        },
        watch: {
            counties: {
                handler(newVal, oldVal) {
                    if (newVal) {
                        this.svgContainer.each(function (i, children) {
                            if (this.node.attributes.title && newVal.includes(this.node.attributes.title.value)) {
                                this.fill({ color: '#ffa534' })
                            }
                            else {
                                this.fill({ color: '#0f8f52' })
                            }
                        }, true);
                    }
                },
                deep: true
            }
        },
        computed: {   
        },
        methods: {
            random: function (max) {
                return Math.floor(Math.random() * Math.floor(max));
            },
            generateVenueMap: function () {
                const vue = this;
                const mapData = irelandMap.g.path;
                const svgContainer = vue.$svg("irelandMap").size('100%', '100%').viewbox(-450, -900, vue.mapAttr.viewBoxWidth, vue.mapAttr.viewBoxHeight);
                vue.svgContainer = svgContainer;
                mapData.forEach((pathObj) => {
                    vue.generatePath(svgContainer, pathObj);
                })
            },
            isInArray(array, value) {
                if (!array) {
                    return false;
                }
                return array.includes(value);
            },
            generatePath: function (svgCont, pathObj) {
                const vue = this;
                const self = this;
                const attrs = {
                    'fill': "#0f8f52",
                    'stroke': "white",
                    'stroke-width': 7,
                    'title': pathObj["-title"],
                    'map-id': pathObj["-id"],
                };

                const element = svgCont.path(pathObj["-d"]).attr(attrs);

                element.click(function (event) {
                    const mapTitle = this.node.attributes["title"].value;
                    vue.$emit("map-clicked", { mapTitle });                    
                });

                element.node.addEventListener('mouseover', (event) => {
                    if (event.target.attributes.fill.value != '#ffa534') {
                        event.target.attributes.fill.value = '#0f8f528a';
                    }
                    event.target.setAttribute('data-toggle', 'tooltip');
                    event.target.innerHTML = "<title>" + event.target.attributes.title.nodeValue + "</title>";
                });

                element.node.addEventListener('mouseleave', (event) => {
                    if (event.target.attributes.fill.value != '#ffa534') {
                        event.target.attributes.fill.value = '#0f8f52';
                    }
                });

            }
        }

    }
</script>
<style>

    .tooltip {
        border-bottom: 1px dotted #333;
        position: relative;
        cursor: pointer;
    }

        .tooltip:hover:after {
            content: attr(title);
            position: absolute;
            white-space: nowrap;
            background: black;
            padding: 3px 7px;
            color: white;
            border-radius: 3px;
            -moz-border-radius: 3px;
            -webkit-border-radius: 3px;
            margin-left: 7px;
            margin-top: -3px;
        }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 1s
    }

    .fade-enter,
    .fade-leave-to
    /* .fade-leave-active in <2.1.8 */ {
        opacity: 0
    }

    .box {
        width: 200px;
        height: 200px;
    }

    .yellow {
        background-color: yellow;
    }

    .blue {
        background-color: blue;
    }
</style>


// WEBPACK FOOTER //
// src/components/user/race-events/race-calendar/map/IrelandMap.vue